import { useCallback } from 'react';
import { facilitiesAPI } from '../../services/api';

export function useFacilityData({ dispatch, useAPI, state }) {
  const updateFacility = useCallback(
    async (facilityData) => {
      try {
        if (useAPI) {
          const response = await facilitiesAPI.create(facilityData);
          if (response.success && response.data) {
            const facilityWithServices = {
              ...response.data,
              services: response.data.services || facilityData.services || [],
            };
            dispatch({ type: 'UPDATE_FACILITY', payload: facilityWithServices });
            return { success: true, data: facilityWithServices };
          }
          throw new Error(response.message || 'Failed to update facility');
        }
        dispatch({
          type: 'UPDATE_FACILITY',
          payload: {
            name: facilityData.name,
            description: facilityData.description,
            services: facilityData.services || [],
          },
        });
        return { success: true };
      } catch (error) {
        console.error('Error updating facility:', error);
        dispatch({
          type: 'UPDATE_FACILITY',
          payload: {
            name: facilityData.name,
            description: facilityData.description,
            services: facilityData.services || [],
          },
        });
        return { success: false, error: error.message };
      }
    },
    [dispatch, useAPI]
  );

  const clearAllData = useCallback(() => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        sessionStorage.clear();
      }
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('topgame_')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => localStorage.removeItem(key));
      dispatch({ type: 'CLEAR_ALL_DATA' });
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error clearing data:', error);
      alert('Error clearing data. Please try again or clear browser storage manually.');
    }
  }, [dispatch]);

  return {
    facility: state.facility,
    grounds: state.grounds,
    updateFacility,
    clearAllData,
  };
}
